import { Component, ElementRef, NgZone, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { CanLeaveRoute } from 'src/app/core/guards/confirmation-guard.guard';
import { CartModel } from 'src/app/shared/models/mazaya-plus/cart-model';
import { MazayaPlusService } from '../../services';
import { MazayaEcardDetails } from 'src/app/shared/models/users/e-cart-details';
import * as CryptoJS from 'crypto-js';
import { Store } from '@ngxs/store';
import { AuthState } from 'src/app/state';
import { MazayaEligibility } from 'src/app/shared/models/mazaya-plus/userInfo';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import { MatRadioChange } from '@angular/material/radio';
import { StorageService } from 'src/app/shared/services/storage.service';
import { Cart, MembershipCategory } from 'src/app/shared/models/mazaya-power/mazaya-power';
import { forEach } from 'lodash';
import { BuyerHistory, MazayaEcardDetail, MazayaeEcardMain, Order, OrderHistoryResponse, TabbyItem, TabbyPaymentRequest } from 'src/app/shared/models/mazaya-plus/tabby-model';
import { MyMazayaPlusService } from 'src/app/features/my-mazaya-plus/services';
import { MazayaEcardData } from 'src/app/shared/models/mazaya-plus/membership-details-model';
import { MatSelectChange } from '@angular/material/select';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { LoginService } from 'src/app/core/services';
import moment from 'moment';

interface MazayaEcardMain {
  amount: number;
  currency: string;
  category_id: number;
  subcategoryIds: string;
  vat: number;
  couponId: number
}

interface Request {
  isReniew: boolean;
  additional_count: number;
  mazayaecarddetails: any[];
  mazayaecardmain: MazayaEcardMain;
}

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent {
  haveCouponCode: boolean = false;
  couponCode: string = '';
  CouponCodeId: number = 0;
  discountAmount: number = 0;
  appliedCouponCode: boolean = false;
  discountModal: boolean = false;
  @ViewChild('formContainer') formContainer: ElementRef;
  // @ViewChild('applePayButton') applePayButton: ElementRef | undefined;
  buyerTermsContent: SafeHtml;
  visibleTermsConditions: boolean = false
  maxDate: Date = this.calculateMaxDate();
  cartItemData: CartModel;
  categoryList: MembershipCategory[] = [];
  cartPower: Cart = {
    items: [], totalAmount: 0, totalVat: 0, grandTotal: 0,
    PowertypeId: 0,
    ExploretypeId: 0,
    powerType: '',
    exploreType: ''
  };
  lastTransaction: { type: string, transactionId: string } = null
  showError: boolean = false;
  totalAmount: number = 0;
  totalVat: number = 0;
  subtotalAmount: number = 0;
  grandTotalAmount: number = 0;
  myForm: FormGroup;
  isInputFocused = false;
  userFirstName = ""
  userLastName = ""
  userDob = ""
  isDisabled: boolean = true;
  isOpen: boolean = false;
  showTabbyPromo: boolean = false;
  tabbyErrorMessage: string | null = null;
  formContent = ``;
  subcategoryIds: string = ""
  token = "";
  today: Date = new Date();
  isChildOnly: boolean = false;
  isNannyOnly: boolean = false;
  relations = [];
  submitted = false;
  userInfo: MazayaEligibility;
  isCreatedCard: boolean = false;
  userEmail: string = "";
  userGender: string = ""
  subcategoryId: number;
  isV2: boolean = false;
  cartType: string = ""
  ipower: boolean = false;
  cartItemV2Data = []
  phoneNumber: string = "";
  gender: string = ""
  mobileNumberError: boolean = false
  isUpgrade: boolean = false
  upgradeAmountTotal: number = 0
  upgradeVatTotal: number = 0
  upgradeGrandTotal: number = 0
  upgradTo: number = 0;
  currency: string = '';
  upgradSubIds: string = "";
  selectedPaymentMethod: string = '';
  isOldToNew: boolean = true
  membershipDetails: any
  membersEmpty: boolean = true
  currentMember: number = 1;
  filteredMembers: any;
  tabbyUrl: SafeResourceUrl;

  selectedTabbyUrl: SafeResourceUrl | null = null;
  isTabbyModalOpen = false;
  isAdult: boolean | null = null;
  loginEmail = JSON.parse(localStorage.getItem('auth.email'));
  isRenew: boolean = false

  selectedMemberIds: (number | null)[] = [];

  haveMainCard: boolean = false
  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _mazayaPlusService: MazayaPlusService,
    private _myMazayaPlusService: MyMazayaPlusService,
    private _storageService: StorageService,
    private store: Store,
    private http: HttpClient,
    private _notification: NotificationsService,
    private zone: NgZone,
    private _route: ActivatedRoute,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private loginService: LoginService,
  ) {
    this.myForm = this.fb.group({
      items: this.fb.array([]),
      agreeConditions: [false, Validators.requiredTrue]
    });
  }

  // calculateCartPowerTotals() {
  //   if (this.cartPower && Array.isArray(this.cartPower)) {
  //       const total = this.cartPower.reduce((acc, item) => {

  //       }, 0);
  //   } else {
  //       console.error('cart is not defined or not an array');
  //   }
  // }

  ngOnInit() {
    // this.fetchPosts();
    // this.buyerTerms();
    this.initUserInfo();
    this._notification.tabbyErrorMessage$.subscribe(
      (message) => (this.tabbyErrorMessage = message)
    );



  }
  initializeTabbyPromo() {

    const tabbyPromo = new (window as any).TabbyPromo({
      selector: '#TabbyPromo',
      currency: 'AED',
      price: this.totalAmount + this.totalVat,
      lang: 'en',
      source: 'product',
      publicKey: 'pk_test_0192ae72-5a88-f236-365e-e94590a650b3',
      merchantCode: 'MPUAE'
    });
    //console.log('TabbyPromo initialized:', tabbyPromo);
  }
  selectPaymentMethod(method: string) {
    this.selectedPaymentMethod = method;
    this.showError = false;
    this.tabbyErrorMessage = null;
  }


  onApplePayButtonClicked(event: Event): void {
    if (!window.ApplePaySession) {
      this._notification.error('', 'Apple Pay is not supported on this device.');
      return;
    }

    const request = {
      countryCode: 'AE',
      currencyCode: 'AED',
      merchantCapabilities: ['supports3DS'],
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      total: {
        label: 'Your Purchase',
        type: 'final',
        amount: this.totalAmount + this.totalVat,
      },
    };

    const session = new ApplePaySession(3, request);
    // console.log('eventRespone1', event);

    // 1 Validate Merchant
    session.onvalidatemerchant = async (event) => {
      try {
        const response = await this._mazayaPlusService.validateApplePayMerchant(event.validationURL).toPromise();
        // console.log({ log: "onvalidatemerchant", response });

        const merchantSession = response.data;
        if (!merchantSession) {
          throw new Error('Invalid merchant session data.');
        }
        session.completeMerchantValidation(merchantSession);
      } catch (error) {
        console.error('Merchant validation failed:', error);
        this._notification.error('', 'Merchant validation failed.');
      }
    };

    session.onpaymentmethodselected = (event) => {
      try {
        // console.log({ log: "onpaymentmethodselected" });
        // console.log('eventRespone3', event);
        const update = {
          newTotal: {
            label: 'Your Purchase',
            type: 'final',
            amount: this.totalAmount + this.totalVat,
          },
        };
        session.completePaymentMethodSelection(update);
      } catch (error) {
        console.error('Error in onpaymentmethodselected', error);
      }
    };

    session.onpaymentauthorized = async (event) => {
      // console.log({ log: "onpaymentauthorized", token: event.payment.token });
      // console.log('eventRespone2', event);

      this.lastTransaction = JSON.parse(localStorage.getItem("lastTransaction"));
      // console.log("Form items:", this.myForm.value.items);

      const paymentData = {
        merchant_reference: this.lastTransaction.transactionId,
        amount: (this.totalAmount + this.totalVat) * 100,
        currency: 'AED',
        language: 'en',
        customer_email: this.userEmail,
        apple_data: event.payment.token.paymentData.data,
        apple_signature: event.payment.token.paymentData.signature,
        apple_header: {
          apple_transactionId: event.payment.token.paymentData.header.transactionId,
          apple_ephemeralPublicKey: event.payment.token.paymentData.header.ephemeralPublicKey,
          apple_publicKeyHash: event.payment.token.paymentData.header.publicKeyHash,
        },
        apple_paymentMethod: {
          apple_displayName: event.payment.token.paymentMethod.displayName,
          apple_network: event.payment.token.paymentMethod.network,
          apple_type: event.payment.token.paymentMethod.type,
        },
        recurring_mode: 'UNSCHEDULED',
      };

      // console.log("transactionId", this.lastTransaction.transactionId);
      // console.log("email", this.userEmail);
      // console.log("paymentRequestBody", paymentData);
      // console.log({ log: "onpaymentauthorized - payment data parameter", paymentData });
      // console.log("ApplePayPaymentRequestBody:", JSON.stringify(paymentData, null, 2));

      try {
        const response = await this._mazayaPlusService.processApplePayPurchase(paymentData).toPromise();
        // console.log({ log: "onpaymentauthorized - purchase request", response });

        if (response.data.success) {
          session.completePayment({ status: ApplePaySession.STATUS_SUCCESS });
          this._notification.success('', 'Payment completed successfully.');
          window.location.href = environment.paymentSuccessurl;
        } else {
          session.completePayment({ status: ApplePaySession.STATUS_FAILURE });
          this._notification.error('', 'Payment failed.');
          window.location.href = environment.paymentFailureurl;
        }
      } catch (error) {
        console.error('Error in onpaymentauthorized', error);
        console.error('Purchase API failed:', error);

        session.completePayment({ status: ApplePaySession.STATUS_FAILURE });
        this._notification.error('', 'Payment failed.');
        window.location.href = environment.paymentFailureurl;
      }
    };

    session.oncanceled = () => {
      // console.log('Payment cancelled');
      this._notification.info('', 'Payment was cancelled.');
    };

    session.begin();
  }

  confirmSelection(): void {
    if (!this.selectedPaymentMethod) {
      this.showError = true; // Show error if no method is selected
    } else {
      // Proceed with confirmation logic
      //console.log('Payment method selected:', this.selectedPaymentMethod);
      this.showError = false;
    }
  }
  createFormPower() {

    this._mazayaPlusService.getUserProfile().subscribe((res: any) => {

      this.userFirstName = res.data.firstName;
      this.userLastName = res.data.lastName;
      this.userEmail = res.data.email;
      this.userDob = (res.data.dob != "Invalid date" && res.data.dob != null) ? moment(res.data.dob, "DD/MM/YYYY").format("YYYY-MM-DD") : '';

      this.phoneNumber = res.data.phoneNumber.substring(3);
      this.gender = res.data.gender;
      this.totalAmount = this.cartPower.totalAmount;
      this.totalVat = this.cartPower.totalVat;
      this.subtotalAmount = this.cartPower.totalAmount + this.discountAmount
      this.grandTotalAmount = this.subtotalAmount + this.totalVat
      this.itemControls.push(
        this.fb.group({
          firstname: [this.userFirstName, Validators.required],
          lastname: [this.userLastName, Validators.required],
          email: [this.userEmail, [Validators.required, Validators.email]],
          dob: [this.userDob, Validators.required],
          sub_type: ["power"],
          relation: 'Myself',
          phoneNumber: this.phoneNumber,
          gender: this.gender,
          totalAmount: this.totalAmount,
          totalVat: this.totalVat
        })
      )



    })

    // ;
  }
  createFormV2() {

    this.amountCalculationV2();
    let mainCount = 0;
    let adultCount = 0;
    let childCount = 0;
    let singleCount = 0;
    let nannyCount = 0;


    for (let i = 0; i < this.cartItemV2Data[0].membershipTypes.length; i++) {

      if (this.cartItemV2Data[0].membershipTypes[i].cardName === "FAMILY MEMBERSHIP") {
        mainCount = this.cartItemV2Data[0].membershipTypes[i].totalCount;
      } else if (this.cartItemV2Data[0].membershipTypes[i].cardName === "SINGLE MEMBERSHIP") {
        singleCount = singleCount + this.cartItemV2Data[0].membershipTypes[i].selectedCount;
      } else if (this.cartItemV2Data[0].membershipTypes[i].cardName === "ADDITIONAL ADULT MEMBERSHIP") {
        adultCount = adultCount + this.cartItemV2Data[0].membershipTypes[i].selectedCount;
      }
      else if (this.cartItemV2Data[0].membershipTypes[i].cardName === "ADDITIONAL CHILD MEMBERSHIP") {
        childCount = childCount + this.cartItemV2Data[0].membershipTypes[i].selectedCount;
      }
      else if (this.cartItemV2Data[0].membershipTypes[i].cardName === "NANNY SERVICE") {
        nannyCount = nannyCount + this.cartItemV2Data[0].membershipTypes[i].selectedCount;
      }
    }
    for (let i = 0; i < mainCount; i++) {
      if (i >= 2) {
        this.itemControls.push(this.createItemFormGroup1("FAMILY", 'Child'));
      } else {
        this.itemControls.push(this.createItemFormGroup1("FAMILY", 'Adult'));
      }

      // if (this.myForm.value.items.length > 0 && i == 0) {
      //   this.getUserProfile();
      // }

    }
    for (let i = 0; i < singleCount; i++) {
      this.itemControls.push(this.createItemFormGroup1("SINGLE", 'Adult'));
      if (this.myForm.value.items.length > 0 && i == 0) {
        this.getUserProfile();
      }
    }
    for (let i = 0; i < adultCount; i++) {
      this.itemControls.push(this.createItemFormGroup1("ADDITIONAL ADULT", 'Adult'));

    }
    for (let i = 0; i < childCount; i++) {
      this.itemControls.push(this.createItemFormGroup1("ADDITIONAL CHILD", 'Child'));
    }
    for (let i = 0; i < nannyCount; i++) {
      this.itemControls.push(this.createItemFormGroup1("NANNY SERVICE", 'Nanny'));
    }
    let famArray = this.cartItemV2Data[0].membershipTypes.find(item => item.cardName === "FAMILY MEMBERSHIP");
    let singleArray = this.cartItemV2Data[0].membershipTypes.find(item => item.cardName === "SINGLE MEMBERSHIP");
    let nannyArray = this.cartItemV2Data[0].membershipTypes.find(item => item.cardName === "NANNY SERVICE");
    if (famArray === undefined || singleArray === undefined) {
      if (this.cartItemV2Data[0].membershipTypes[0].cardName === "ADDITIONAL CHILD MEMBERSHIP") {
        this.isChildOnly = true;
      }


    }


    // for (let i = 1; i < totalCount; i++) {
    //   this.addItem();
    // }
    for (let i = 0; i < this.cartItemV2Data[0].membershipTypes.length; i++) {
      if (i != 0)
        this.subcategoryIds = this.subcategoryIds + "," + this.cartItemV2Data[0].membershipTypes[i].cardId.toString()
      else
        this.subcategoryIds = this.cartItemV2Data[0].membershipTypes[i].cardId.toString()
    }
    this.haveMainCard = mainCount > 0 || singleCount > 0
    if (this.isOldToNew) {
      this.relations = [
        { value: 'Myself', viewValue: 'Myself' },
        { value: 'Father', viewValue: 'Father' },
        { value: 'Mother', viewValue: 'Mother' },
        { value: 'Son', viewValue: 'Son' },
        { value: 'Daughter', viewValue: 'Daughter' },
        { value: 'Spouse', viewValue: 'Spouse' },
        { value: 'Other', viewValue: 'Other' },
      ]
      this.isRenew = this.userInfo.isAbletoRenew && (mainCount > 0 || singleCount > 0)
      this._myMazayaPlusService.getEcardsRenew(true)
        .subscribe((res) => {
          this.membershipDetails = res.data
          this.currentMember = 2
          this.handleLeftArrow()

          if ((this.membershipDetails.length > 0 && this.membershipDetails[0].relation == 'Myself' && this.userInfo?.mazayaCardCount === 0) || (this.membershipDetails.length > 0 && this.isRenew)) {
            this.myForm.get('items.0').setValue({
              firstname: this.membershipDetails[0].firstname,
              lastname: this.membershipDetails[0].lastname,
              email: this.membershipDetails[0].email,
              dob: this.membershipDetails[0].dob,
              relation: this.membershipDetails[0].relation,
              gender: this.membershipDetails[0].gender == "" ? this.gender : this.membershipDetails[0].gender,
              phoneNumber: this.phoneNumber,
              sub_type: singleCount == 1 ? 'SINGLE' : 'FAMILY',
              selection: 'new',
              profile_image: this.membershipDetails[0].profile_img,
              memberType: 'Adult'
            });
          } else {
            this.getUserProfile()
          }

        })

    }


  }
  loadCart(): void {
    const storedCart = localStorage.getItem('cartPower');
    this.cartPower = storedCart
      ? JSON.parse(storedCart)
      : { items: [], totalAmount: 0, totalVat: 0, grandTotal: 0 };
    this.createFormPower()
  }
  deleteCartItem(index: number): void {
    const lastObjIsExplore = this.cartPower.items[0].cardName.includes('Explore') ? true : false;
    this.cartPower.items.splice(index, 1);
    this.cartPower.totalAmount = this.cartPower.items.reduce((sum, item) => sum + item.amount * item.count, 0);
    this.cartPower.totalVat = this.cartPower.items.reduce((sum, item) => sum + item.vat * item.count, 0);
    this.cartPower.grandTotal = this.cartPower.totalAmount + this.cartPower.totalVat;

    localStorage.setItem('cartPower', JSON.stringify(this.cartPower));
    this._notification.clearTabbyErrorMessage();

    if (this.cartPower.items.length == 0) {
      if (lastObjIsExplore)
        this._router.navigate(["/mazaya-explore"]);
      else
        this._router.navigate(["/mazaya-power"]);
    }
    this.amountCalculationPowerCart()
  }
  trackByFn(index: number, item: any): any {
    return item.id; // Replace with a unique identifier for each item in your case
  }
  get itemControls() {
    return this.myForm.get('items') as FormArray;
  }

  createItemFormGroup() {
    return this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      dob: ['', Validators.required],
      relation: ['', Validators.required],
      gender: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.minLength(9)]],
      sub_type: [""],

    });
  }

  createItemFormGroup1(subtype: string, memberType: string) {
    return this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      dob: ['', Validators.required],
      relation: ['', Validators.required],
      gender: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.minLength(9)]],
      sub_type: [subtype],
      selection: 'new',
      profile_image: '',
      memberType: memberType
    });

  }
  addItem() {
    this.itemControls.push(this.createItemFormGroup());
  }

  removeItem(index: number) {

    this.itemControls.removeAt(index);

  }

  amountCalculation() {
    this.totalVat = 0;
    this.totalAmount = 0;

    for (let i = 0; i < this.cartItemData.subCategory.length; i++) {
      this.totalVat = this.totalVat + (this.cartItemData.subCategory[i].vat) * this.cartItemData.subCategory[i].count
      this.totalAmount = this.totalAmount + (this.cartItemData.subCategory[i].amount) * this.cartItemData.subCategory[i].count

    }
    this.grandTotalAmount = this.totalAmount

  }
  onIncrement(i: number) {
    if (this.cartItemData.subCategory[i].count != this.cartItemData.subCategory[i].totalcount) {
      this.cartItemData.subCategory[i].count++
      localStorage.setItem('cart', JSON.stringify(this.cartItemData));
      this._notification.clearTabbyErrorMessage();
      this.amountCalculation()

      if (this.cartItemData.subCategory[i].sub_type === "ADDITIONAL ADULT") {
        this.itemControls.push(this.createItemFormGroup1("ADDITIONAL ADULT", 'Adult'));
        this._notification.clearTabbyErrorMessage();

      }
      if (this.cartItemData.subCategory[i].sub_type === "ADDITIONAL CHILD") {
        this.itemControls.push(this.createItemFormGroup1("ADDITIONAL CHILD", 'Child'));
        this._notification.clearTabbyErrorMessage();
      }
    } else {
      this._notification.error(
        "",
        "Maximum count reached"
      );
    }

  }
  onDecrement(i: number) {
    if (this.cartItemData.subCategory[i].count !== 0) {
      this.cartItemData.subCategory[i].count--
      localStorage.setItem('cart', JSON.stringify(this.cartItemData));

      if (this.cartItemData.subCategory.length > 1 && this.userInfo?.mazayaCardCount != 0) {

        this.removeItem(0)
      } else {
        this.removeItem(this.itemControls.controls.length - 1)

      }

      if (this.cartItemData.subCategory[i].count == 0)
        this.deleteSubCategory(i);
      this.amountCalculation();
    }
  }
  onInputFocus() {
    this.isInputFocused = true;
  }

  onInputBlur() {
    this.isInputFocused = false;
  }

  async confirm(nextState?: RouterStateSnapshot) {

  }
  getUserProfile() {
    this._mazayaPlusService.getUserProfile().subscribe((res: any) => {

      this.userFirstName = res.data.firstName;
      this.userLastName = res.data.lastName;
      this.userEmail = res.data.email;
      this.phoneNumber = res.data.phoneNumber.substring(3);
      this.gender = res.data.gender;
      this.userDob = (res.data.dob != "Invalid date" && res.data.dob != null) ? moment(res.data.dob, "DD/MM/YYYY").format("YYYY-MM-DD") : '';
      if (this.userInfo?.mazayaCardCount === 0) {

        this.isCreatedCard = false
        //console.log("userFirstName2", this.myForm.value.items.length, this.userFirstName)
        this.myForm.value.items.length

        this.myForm.get('items.0').setValue({
          firstname: res.data.firstName,
          lastname: res.data.lastName,
          email: res.data.email,
          dob: this.userDob,
          relation: 'Myself',
          sub_type: this.myForm.get('items.0.sub_type').value,
          phoneNumber: this.phoneNumber,
          gender: this.gender,
          selection: 'new',
          profile_image: '',
          memberType: 'Adult'
        });
      } else {
        this.isCreatedCard = true;
      }
    })

  }

  onSubmitPower() {
    this.submitted = true;
    if (!this.selectedPaymentMethod) {
      this.showError = true;
      this._notification.error("", "Please select a payment method before proceeding.");
      return;
    } else {
      this.showError = false;
    }
    if (!this.myForm.valid) {
      return;
    }
    const itemControl = this.myForm.get('items.0');

    if (!itemControl) {
      this._notification.error("", "No members found.");
      return;
    }
    const formValue = itemControl.value;
    const date = moment(formValue.dob)
    const formattedDob = date.format('YYYY-MM-DD');
    const mazayaecarddetails = this.cartPower.items.map((item) => ({
      firstname: formValue.firstname,
      lastname: formValue.lastname,
      email: formValue.email,
      dob: formattedDob,
      relation: formValue.relation,
      gender: formValue.gender,
      sub_type: item.cardName,
      type: item.type?.toUpperCase(),
      phoneNumber: '971' + formValue.phoneNumber,
      subcategoryId: Number(item.cardId),
      categoryId: Number(item.catId)
    }));
    const currency = this.cartPower.items.length > 0 ? this.cartPower.items[0].currency : '';
    const catIds = this.cartPower.items.map(card => card.catId).join(",");


    const exploreTypeId = catIds ? `${catIds}` : '';
    const powerTypeId = this.cartPower.PowertypeId ? `${this.cartPower.PowertypeId}` : '';

    const categoryIds = catIds;

    const subcategoryIds = this.cartPower.items.map((item) => item.cardId).join(',');

    let mazayaType = 0;
    if ((this.cartPower.powerType.toUpperCase() === 'MAZAYA PRIME' || this.cartPower.powerType.toUpperCase() === "MAZAYA SUPER" || this.cartPower.powerType.toUpperCase() === "MAZAYA ULTRA"
    ) && (
        this.cartPower.exploreType.toUpperCase() == "MAZAYA ASIA EXPLORE" ||
        this.cartPower.exploreType.toUpperCase() == "MAZAYA EUROPE EXPLORE" ||
        this.cartPower.exploreType.toUpperCase() == "MAZAYA AMERICA EXPLORE"
        || this.cartPower.exploreType.toUpperCase() == "MAZAYA GLOBAL EXPLORE")) {
      mazayaType = 4;
    } else if (this.cartPower.powerType.toUpperCase() === 'MAZAYA PRIME' || this.cartPower.powerType.toUpperCase() === "MAZAYA SUPER" || this.cartPower.powerType.toUpperCase() === "MAZAYA ULTRA") {
      mazayaType = 3;
    } else if (this.cartPower.exploreType.toUpperCase() == "MAZAYA ASIA EXPLORE" ||
      this.cartPower.exploreType.toUpperCase() == "MAZAYA EUROPE EXPLORE" ||
      this.cartPower.exploreType.toUpperCase() == "MAZAYA AMERICA EXPLORE"
      || this.cartPower.exploreType.toUpperCase() == "MAZAYA GLOBAL EXPLORE") {
      mazayaType = 2;
    }

    const mazayaecardmain = {
      amount: this.subtotalAmount,
      currency: currency,
      category_ids: categoryIds,
      subcategoryIds: subcategoryIds,
      vat: this.totalVat,
      mazayaType: mazayaType,
      couponId: this.CouponCodeId == 0 ? null : this.CouponCodeId
    };

    const requestBody = {
      mazayaecarddetails,
      mazayaecardmain,
    };

    //console.log("Request Body:", requestBody);


    this._mazayaPlusService.createPower(requestBody).subscribe({
      next: (response) => {
        // this._notification.success("", "Power card created successfully!");
        //console.log("Response:", response);
        if (response.statusCode == 200) {
          const lastTransaction: { type: string, transactionId: string } = {
            type: this.cartType,
            transactionId: response.data.transaction_id
          }


          localStorage.setItem('lastTransaction', JSON.stringify(lastTransaction))
          if (this.grandTotalAmount != 0) {
            if (this.selectedPaymentMethod === 'Credit/Debit Card') {

              this.handlePowerPayment(response.data.transaction_id, requestBody.mazayaecarddetails[0].email);
            } else if (this.selectedPaymentMethod === 'Tabby') {

              this.createPowerPaymentWithTabby(response.data.transaction_id);
            } else if (this.selectedPaymentMethod === 'ApplePay') {
              this.isOpen = true;
            }

          }
          else {
            this.updatePowerExploreStatusWithoutPayment(response.data.transaction_id)
          }
        } else {
          this._notification.error("Failed", "Please enter a valid Email");
        }
      },
      error: (error) => {
        this._notification.error("", "Failed to create Power card");
        console.error("Error:", error);
      },
    });
  }

  createPowerPaymentWithTabby(transaction_id: number) {

    //console.log("createPaymentWithTabby called with transaction_id:", transaction_id);
    //console.log("ghhhhhhhhhhhhhhh", this.myForm.value.items);

    const currency = this.cartPower.items.length > 0 ? this.cartPower.items[0].currency : '';

    const exploreTypeId = this.cartPower.ExploretypeId ? `${this.cartPower.ExploretypeId}` : '';
    const powerTypeId = this.cartPower.PowertypeId ? `${this.cartPower.PowertypeId}` : '';

    const categoryIds = [exploreTypeId, powerTypeId].filter((id) => id).join(',');

    const subcategoryIds = this.cartPower.items.map((item) => item.cardId).join(',');

    let mazayaType = 0;
    if (this.cartPower.powerType === "Mazaya Power" && this.cartPower.exploreType === "Mazaya Explore") {
      mazayaType = 4;
    } else if (this.cartPower.powerType === "Mazaya Power") {
      mazayaType = 3;
    } else if (this.cartPower.exploreType === "Mazaya Explore") {
      mazayaType = 2;
    }
    const itemControl = this.myForm.get('items.0');

    if (!itemControl) {
      this._notification.error("", "No members found.");
      return;
    }
    const formValue = itemControl.value;
    const tabbyPaymentData: TabbyPaymentRequest = {
      additional_count: 0,
      mazayaecarddetails: this.cartPower.items.map((item) => ({
        firstname: formValue.firstName,
        lastname: formValue.lastName,
        email: formValue.email,
        dob: formValue.dob,
        relation: formValue.relation,
        gender: formValue.gender,
        sub_type: item.cardName,
        mazayaEcardmainId: 0,
        phone: '971' + formValue.phoneNumber
      })),
      mazayaecardmain: {
        category_id: Number(categoryIds),
        vat: this.totalVat,
        amount: this.totalAmount,
        currency: currency,
        id: Number(categoryIds),
        subcategoryIds: subcategoryIds,
      },
      orderHistory: [
        {
          purchased_at: new Date().toISOString(),
          amount: this.totalAmount,
          status: "new",
          buyer: {
            phone: '971' + formValue.phoneNumber,
            email: formValue.email,
            name: formValue.firstname + " " + formValue.lastname
          },
          shipping_address: {
            city: "Abu Dhabi Auh",
            address: "Auh",
            zip: "000000"
          }
        }
      ],
      buyerHistory: {
        registered_since: new Date().toISOString(),
        loyalty_level: 0
      },
      items: [{
        title: this.cartPower.powerType,
        quantity: 1,
        unit_price: this.totalAmount,
        category: this.cartPower.powerType
      }],

      name: "Family",
      booking_id: transaction_id,
      description: "Mazaya Ecard Payment",
      device_type: 'web'
    };


    //console.log("TabbyPaymentData:", tabbyPaymentData);

    //console.log("Tabby Payment Data:", tabbyPaymentData);


    this._mazayaPlusService.createPayment(tabbyPaymentData).subscribe(
      (res) => {

        //console.log("Tabby payment response:", res);
        const paymentUrl = res.data;
        window.location.href = paymentUrl;

      },
      (error) => {
        console.error("Tabby payment request failed:", error);
        // if (error.statusCode === 400 && error.error?.data === "order_amount_too_high") {

        this._notification.error("High Amount", "Order amount is too high.");
        // } else {
        //   this._notification.error("Payment Failed", "An error occurred during payment processing.");
        // }
      }
    );
  }





  checkAllSpecificFieldsEmpty(item: FormGroup, fieldsToCheck: string[]): boolean {
    return fieldsToCheck.every(field => {
      const control = item.get(field);
      const value = control?.value;

      return value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
    });
  }

  onSubmit() {

    // this.currentMember = 1
    this.submitted = true

    if (!this.selectedPaymentMethod) {
      this.showError = true;
      this._notification.error("", "Please select a payment method before proceeding.");
      return;
    } else {
      this.showError = false;
    }


    if (this.totalAmount === 0) {
      this._notification.error("", " Please add a member");
      return
    }

    const itemsArray = this.myForm.get('items') as FormArray;

    for (let index = 0; index < itemsArray.controls.length; index++) {
      const item = itemsArray.at(index) as FormGroup;

      const fieldsToCheck = ['firstname', 'lastname', 'email', 'dob', 'relation', 'gender', 'phoneNumber'];

      if (this.checkAllSpecificFieldsEmpty(item, fieldsToCheck)) {
        //console.log("✅ All required fields are empty");
      } else {

        if (item.get('firstname')?.value == '') {
          this._notification.error("Failed", `First name is required at position ${index + 1}`);
          return
        }
        if (item.get('lastname')?.value == '') {
          this._notification.error("Failed", `Last name is required at position ${index + 1}`);
          return
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const email = item.get('email')?.value;
        if (!emailPattern.test(email)) {
          this._notification.error("Failed", `Invalid email at position ${index + 1}`);
          return
        }
        const phoneNumber = item.get('phoneNumber')?.value;
        if (phoneNumber.length != 9) {
          this._notification.error("Failed", `Mobile number must be 9 digit at postion ${index + 1}`);
          return
        }
        if (item.get('dob')?.value == '') {
          this._notification.error("Failed", `Date of birth is required at position ${index + 1}`);
          return
        }
        if (item.get('relation')?.value == '') {
          this._notification.error("Failed", `Relation is required at position ${index + 1}`);
          return
        }
        if (item.get('gender')?.value == '') {
          this._notification.error("Failed", `Gender is required at position ${index + 1}`);
          return
        }

      }
    }


    let isZeroPosError: boolean = false
    const firstGroup = this.myForm.get('items.0') as FormGroup;

    if (firstGroup) {
      Object.keys(firstGroup.controls).forEach((key, index) => {
        if (this.myForm.get('items.0.dob').value !== '' && key == 'dob') {
          isZeroPosError = true
          return
        }
        const control = firstGroup.get(key);
        if (control?.invalid) {

          //console.log(`${key} is invalid`, control.errors);
        }
      });
    }

    if (this.myForm.get('items.0').valid && this.myForm.get('agreeConditions')?.valid) {
      let request: Request = {
        "isReniew": this.isRenew,
        "additional_count": 0,
        "mazayaecarddetails": [],
        "mazayaecardmain": {
          "amount": 0,
          "currency": "",
          "category_id": 0,
          "subcategoryIds": "",
          "couponId": 0,
          "vat": 0
        }
      }
      //console.log(this.cartItemV2Data)
      if (this.isV2) {
        const cards = this.cartItemV2Data[0]?.membershipTypes.filter(i => i.count != 0)
        this.upgradSubIds = cards.map(card => card.cardId).join(',');

        request.additional_count = this.cartItemV2Data[0]?.membershipTypes.length == 2 ? this.cartItemV2Data[0].membershipTypes[1].count : 0
        request.mazayaecarddetails = this.myForm.get('items')?.getRawValue(),
          request.mazayaecardmain.amount = this.subtotalAmount,
          request.mazayaecardmain.currency = this.cartItemV2Data[0]?.membershipTypes[0].currency,
          request.mazayaecardmain.category_id = this.cartItemV2Data[0]?.typeId,
          request.mazayaecardmain.subcategoryIds = this.subcategoryIds,
          request.mazayaecardmain.vat = this.totalVat
        request.mazayaecardmain.couponId = this.CouponCodeId == 0 ? null : this.CouponCodeId

      } else {
        request.additional_count = this.cartItemData?.subCategory.length == 2 ? this.cartItemData.subCategory[1].count : 0
        request.mazayaecarddetails = this.myForm.get('items')?.getRawValue(),
          request.mazayaecardmain.amount = this.subtotalAmount,
          request.mazayaecardmain.currency = this.cartItemData?.subCategory[0].currency,
          request.mazayaecardmain.category_id = this.cartItemData?.categoryId,
          request.mazayaecardmain.subcategoryIds = this.subcategoryIds,
          request.mazayaecardmain.vat = this.totalVat
      }


      request.mazayaecarddetails[0].firstname = request.mazayaecarddetails[0].firstname.trim();
      request.mazayaecarddetails[0].lastname = request.mazayaecarddetails[0].lastname.trim();
      request.mazayaecarddetails[0].gender = request.mazayaecarddetails[0].gender;
      request.mazayaecarddetails.forEach((element, index) => {

        const date = moment(request.mazayaecarddetails[index].dob);
        const formattedDob = date.format('YYYY-MM-DD');
        request.mazayaecarddetails[index].dob = formattedDob == 'Invalid date' ? request.mazayaecarddetails[index].dob : formattedDob

        if (request.mazayaecarddetails[index].phoneNumber != '')
          request.mazayaecarddetails[index].phoneNumber = this.checkStartsWith971(request.mazayaecarddetails[index].phoneNumber) ? request.mazayaecarddetails[index].phoneNumber : '971' + request.mazayaecarddetails[index].phoneNumber;
      });
      let abc = request
      this._mazayaPlusService.createEcard(request)
        .subscribe((res) => {

          //console.log(res)
          if (res.data != 0) {

            const lastTransaction: { type: string, transactionId: string } = {
              type: this.cartType,
              transactionId: res.data.transaction_id

            }
            //console.log("transacccction", lastTransaction)
            if (res.data.transaction_id != 0)
              localStorage.setItem('lastTransaction', JSON.stringify(lastTransaction))

            if (this.grandTotalAmount != 0) {
              if (this.selectedPaymentMethod === 'Credit/Debit Card') {
                this.handlePayment(res.data.transaction_id, request.mazayaecarddetails[0].email);
              } else if (this.selectedPaymentMethod === 'Tabby') {
                this.createPaymentWithTabby(res.data);
              } else if (this.selectedPaymentMethod === 'ApplePay') {
                this.isOpen = true;
              }
              else if (this.selectedPaymentMethod === 'ApplePay') {
                this.isOpen = true;
              }
            }
            else {
              this.updateECardStatusWithoutPayment(res.data.transaction_id)
            }




          } else {
            this._notification.error("Failed", " Please enter a valid Email");
          }


        })

    } else {
      const firstGroup = this.myForm.get('items.0') as FormGroup;

      if (firstGroup) {
        Object.keys(firstGroup.controls).forEach(key => {
          const control = firstGroup.get(key);
          if (control?.invalid) {

            //console.log(`${key} is invalid`, control.errors);
          }
        });
      }
    }

  }
  createPaymentWithTabby(transaction_id: number) {


    //console.log("createPaymentWithTabby called with transaction_id:", transaction_id);
    //console.log("Form items:", this.myForm.value.items);
    //console.log("Cart Item V2 Data:", this.cartItemV2Data);


    let tabbyPaymentData: TabbyPaymentRequest;

    if (this.isV2) {

      tabbyPaymentData = {
        additional_count: this.cartItemV2Data[0]?.membershipTypes.length === 2
          ? this.cartItemV2Data[0].membershipTypes[1].count
          : 0,
        mazayaecarddetails: this.myForm.value.items.map((item: any) => ({
          email: item.email.trim(),
          dob: moment(item.dob).format('YYYY-MM-DD'),
          relation: item.relation,
          lastname: item.lastname.trim(),
          firstname: item.firstname.trim(),
          sub_type: item.sub_type,
          mazayaEcardmainId: 0,
          gender: item.gender,
          phone: item.phoneNumber
        })),
        mazayaecardmain: {
          category_id: this.cartItemV2Data[0]?.typeId,
          vat: this.totalVat,
          amount: this.totalAmount,
          currency: this.cartItemV2Data[0]?.membershipTypes[0]?.currency,
          id: this.cartItemV2Data[0]?.typeId,
          subcategoryIds: this.subcategoryIds,
        },
        orderHistory: [
          {
            purchased_at: new Date().toISOString(),
            amount: this.totalAmount,
            status: "new",
            buyer: {
              phone: this.myForm.value.items[0].phoneNumber,
              email: this.myForm.value.items[0].email,
              name: this.myForm.value.items[0].firstname + " " + this.myForm.value.items[0].lastname
            },
            shipping_address: {
              city: "Abu Dhabi Auh",
              address: "Auh",
              zip: "000000"
            }
          }
        ],
        buyerHistory: {
          registered_since: new Date().toISOString(),
          loyalty_level: 0
        },
        items: this.cartItemV2Data[0].membershipTypes.map((item: any) => ({
          title: item.cardName,
          quantity: item.count,
          unit_price: item.amount,
          category: this.cartItemV2Data[0].type
        })),
        name: "Family Membership",
        booking_id: transaction_id,
        description: "Mazaya Ecard Payment",
        device_type: 'web'
      };
    } else {

      tabbyPaymentData = {
        additional_count: this.cartItemData?.subCategory.length === 2
          ? this.cartItemData.subCategory[1].count
          : 0,
        mazayaecarddetails: this.myForm.value.items.map((item: any) => ({
          email: item.email.trim(),
          dob: moment(item.dob).format('YYYY-MM-DD'),
          relation: item.relation,
          lastname: item.lastname.trim(),
          firstname: item.firstname.trim(),
          sub_type: item.sub_type,
          mazayaEcardmainId: 0,
          gender: item.gender,
          phone: item.phoneNumber
        })),
        mazayaecardmain: {
          category_id: this.cartItemData?.categoryId,
          vat: this.totalVat,
          amount: this.totalAmount,
          currency: this.cartItemData?.subCategory[0]?.currency,
          id: this.cartItemData?.categoryId,
          subcategoryIds: this.subcategoryIds,
        },
        orderHistory: [
          {
            purchased_at: new Date().toISOString(),
            amount: this.totalAmount,
            status: "new",
            buyer: {
              phone: this.myForm.value.items[0].phoneNumber,
              email: this.myForm.value.items[0].email,
              name: this.myForm.value.items[0].firstname + " " + this.myForm.value.items[0].lastname
            },
            shipping_address: {
              city: "Abu Dhabi Auh",
              address: "Auh",
              zip: "000000"
            }
          }
        ],
        buyerHistory: {
          registered_since: new Date().toISOString(),
          loyalty_level: 0
        },
        items: this.cartItemV2Data[0].membershipTypes.map((item: any) => ({
          title: item.cardName,
          quantity: item.count,
          unit_price: item.amount,
          category: this.cartItemV2Data[0].type
        })),

        name: "Family Membership",
        booking_id: transaction_id,
        description: "Mazaya Ecard Payment",
        device_type: 'web'
      };
    }


    //console.log("Tabby Payment Data:", tabbyPaymentData);
    //console.log("Tabby Payment Data:", JSON.stringify(tabbyPaymentData, null, 2));


    this._mazayaPlusService.createPayment(tabbyPaymentData).subscribe(

      (res) => {
        //console.log("Tabby payment response:", res);
        const paymentUrl = res.data;

        window.location.href = paymentUrl;
      },
      (error) => {

        console.error("Tabby payment request failed:", error);

        this._notification.error("High Amount", "Order amount is too high.");

      }
    );
  }

  payment(data: any): Observable<any> {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
    let options = { headers: headers };
    return this.http.post<any>(
      'https://sbpaymentservices.payfort.com/FortAPI/paymentApi',
      data,
      options,
    )
  }

  checkout() {
    const currentTimestamp = new Date().getTime();
    const data = {
      payfortactlink: 'https://sbcheckout.payfort.com/FortAPI/paymentPage',
      payfortcommand: 'AUTHORIZATION',
      payfortaccesscode: 'pXOgNQvchAF3hPktmdNN',
      payfortmerchantidentifier: 'uBtRIcqH',
      totpayamount: '2000',
      payfortcurrency: 'AED',
      payfortlanguage: 'en',
      customeremail: 'test@gmail.com',
      bookrefnum: currentTimestamp,
      customer_ip: '103.178.205.183',
      signature: '',
    };

    var text = `cnsduifgwegfyaccess_code=${data.payfortaccesscode}amount=${data.totpayamount}command=${data.payfortcommand}currency=${data.payfortcurrency}customer_email=${data.customeremail}customer_ip=${data.customer_ip}language=${data.payfortlanguage}merchant_identifier=${data.payfortmerchantidentifier}merchant_reference=${data.bookrefnum}cnsduifgwegfy`;
    const sha256Hash = this.calculateSHA256(text);
    data.signature = sha256Hash;


    this._mazayaPlusService.payment(data).subscribe(res => {

    })
    // this.http
    //   .post<any>(
    //     'https://sbpaymentservices.payfort.com/FortAPI/paymentApi',
    //     data,
    //     options,
    //   )
    //   .pipe(
    //     catchError((error: any, caught: Observable<any>): Observable<any> => {
    //       this.errorMessage = error.message;
    //       return of();
    //     }),
    //   )
    //   .subscribe((data) => {
    //     this.response = data;
    //   });
  }
  handlePowerPayment(transaction_id: number, email: string) {

    this.store.select(AuthState.token).subscribe((token) => {
      //  this.token = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vaHViLm1hdHJpeC5jb20vIiwic3ViIjoieE9RTVY0aG0xeWs9IiwiZXhwIjoxNjk4OTIzMjA5fQ.R0voJ9K_7dyxF3vM9B7e7pP8z0YSD4GwASRFgeoxAo4";
    })


    const isMazayaPlus = localStorage.getItem('auth.email');


    const payfortactlink = environment.payfortactlink;
    const payfortcommand = environment.payfortcommand;
    const payfortaccesscode = environment.payfortaccesscode;
    const payfortmerchantidentifier = environment.payfortmerchantidentifier;
    const shaRequest = environment.shaRequest;




    const totpayamount = Math.round(this.roundAmount(this.grandTotalAmount) * 100);
    const payfortcurrency = 'AED';
    const payfortlanguage = 'en';
    const customeremail = email;
    const currentTimestamp = new Date().getTime();
    const bookrefnum = transaction_id;

    const host_url = `${window.location.origin}/`;
    //const host_url = "http://localhost:4200/";
    const resource = environment.nodeServerUrl1
    const return_url = `${resource}/payment/power-explore/payment-statusweb?paymentGwayId=${bookrefnum}&successReturnUrl=${host_url}home/payment-success&failureReturnUrl=${host_url}home/payment-failure`

    var text = `${shaRequest}access_code=${payfortaccesscode}amount=${totpayamount}command=${payfortcommand}currency=${payfortcurrency}customer_email=${customeremail}language=${payfortlanguage}merchant_identifier=${payfortmerchantidentifier}merchant_reference=${'P-' + transaction_id.toString()}return_url=${return_url}${shaRequest}`
    const sha256Hash = this.calculateSHA256(text);

    this.formContent = `<form #form method="post" action="${payfortactlink}">
    <input type="hidden" name="command" value="${payfortcommand}" id="command" />
    <input type="hidden" name="access_code" value="${payfortaccesscode}" id="access_code" />
    <input type="hidden" name="merchant_identifier" value="${payfortmerchantidentifier}" id="merchant_identifier" />
    <input type="hidden" name="amount" value="${totpayamount}" id="amount" />
    <input type="hidden" name="currency" value="${payfortcurrency}" id="currency" />
    <input type="hidden" name="language" value="${payfortlanguage}" id="language" />
    <input type="hidden" name="customer_email" value="${customeremail}" id="customeremail" />
    <input type="hidden" name="signature" value="${sha256Hash}" id="signature" />
    <input type="hidden" name="return_url" value="${return_url}" id="return_url" />
    
    <input type="hidden" name="merchant_reference" value="${'P-' + transaction_id.toString()}" id="merchant_reference" />
    <input type="submit" value="PAY" id="btnGoToPG" ref="payBtn" style="display:none;" />
  </form>`
    this.formContainer.nativeElement.innerHTML = this.formContent;
    const form = this.formContainer.nativeElement.querySelector('form');

    form.submit();
  }

  handlePayment(transaction_id: number, email: string) {


    this.store.select(AuthState.token).subscribe((token) => {
      //  this.token = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vaHViLm1hdHJpeC5jb20vIiwic3ViIjoieE9RTVY0aG0xeWs9IiwiZXhwIjoxNjk4OTIzMjA5fQ.R0voJ9K_7dyxF3vM9B7e7pP8z0YSD4GwASRFgeoxAo4";
    })


    const isMazayaPlus = localStorage.getItem('auth.email');


    const payfortactlink = environment.payfortactlink;
    const payfortcommand = environment.payfortcommand;
    const payfortaccesscode = environment.payfortaccesscode;
    const payfortmerchantidentifier = environment.payfortmerchantidentifier;
    const shaRequest = environment.shaRequest;




    const totpayamount = Math.round(this.roundAmount(this.grandTotalAmount) * 100);
    const payfortcurrency = 'AED';
    const payfortlanguage = 'en';
    const customeremail = email;
    const currentTimestamp = new Date().getTime();
    const bookrefnum = transaction_id;
    const host_url = `${window.location.origin}/`;
    //const host_url = "http://localhost:4200/";
    const resource = environment.nodeServerUrl1
    const return_url = `${resource}/payment/payment-statusweb?paymentGwayId=${bookrefnum}`
    // const return_url = `${resource}/Paymentweb/Paymentwebstatus?paymentGwayId=${bookrefnum}&successReturnUrl=${host_url}home/payment-success&failureReturnUrl=${host_url}home/payment-failure`

    var text = `${shaRequest}access_code=${payfortaccesscode}amount=${totpayamount}command=${payfortcommand}currency=${payfortcurrency}customer_email=${customeremail}language=${payfortlanguage}merchant_identifier=${payfortmerchantidentifier}merchant_reference=${bookrefnum}return_url=${return_url}${shaRequest}`
    const sha256Hash = this.calculateSHA256(text);

    this.formContent = `<form #form method="post" action="${payfortactlink}">
    <input type="hidden" name="command" value="${payfortcommand}" id="command" />
    <input type="hidden" name="access_code" value="${payfortaccesscode}" id="access_code" />
    <input type="hidden" name="merchant_identifier" value="${payfortmerchantidentifier}" id="merchant_identifier" />
    <input type="hidden" name="amount" value="${totpayamount}" id="amount" />
    <input type="hidden" name="currency" value="${payfortcurrency}" id="currency" />
    <input type="hidden" name="language" value="${payfortlanguage}" id="language" />
    <input type="hidden" name="customer_email" value="${customeremail}" id="customeremail" />
    <input type="hidden" name="signature" value="${sha256Hash}" id="signature" />
    <input type="hidden" name="return_url" value="${return_url}" id="return_url" />
    
    <input type="hidden" name="merchant_reference" value="${bookrefnum}" id="merchant_reference" />
    <input type="submit" value="PAY" id="btnGoToPG" ref="payBtn" style="display:none;" />
  </form>`
    this.formContainer.nativeElement.innerHTML = this.formContent;
    const form = this.formContainer.nativeElement.querySelector('form');

    form.submit();
  }

  calculateSHA256(input: string): string {
    const hash = CryptoJS.SHA256(input);
    return hash.toString(CryptoJS.enc.Hex);
  }

  addBreakLine(name: string): string {
    return name.replace(/ /g, '<br/>')
  }
  calculateMaxDate(): Date {
    const today = new Date();
    const maxDate = new Date(today);
    maxDate.setFullYear(today.getFullYear() - 18);
    return maxDate;
  }
  initUserInfo() {
    this._mazayaPlusService.getUserInfo().subscribe((res) => {
      this.userInfo = res.data




      setInterval(() => {
        const localStorageValue = localStorage.getItem('cart');

        if (localStorageValue && localStorageValue !== "undefined") {
          const data = JSON.parse(localStorageValue);
          this.cartItemData = data

          this.amountCalculation();
          const price = this.grandTotalAmount;
          this.tabbyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://checkout.tabby.ai/promos/product-page/installments/en/?price=${price}&currency=AED`
          );
        }

      }, 1000);

      const storedData = localStorage.getItem('cart');


      if (storedData && storedData !== "undefined") {
        this.isV2 = false;
        this.cartType = "v1-cart"
        const data = JSON.parse(storedData);
        this.cartItemData = data

      }



      const mazayaPlusV2Data = localStorage.getItem('v2-cart');
      if (mazayaPlusV2Data && mazayaPlusV2Data !== "undefined") {
        this.isV2 = true;
        this.cartType = "v2-cart"
        const data = JSON.parse(mazayaPlusV2Data);
        this.cartItemV2Data = data
        //console.log("cartItemV2Data", this.cartItemV2Data)
        // this.isOldToNew = this.cartItemV2Data[0].isOldToNew
        this.amountCalculationV2();
        const price = this.grandTotalAmount;
        this.tabbyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://checkout.tabby.ai/promos/product-page/installments/en/?price=${price}&currency=AED`
        );
      }
      if (this.cartType === "v1-cart") {

        this.amountCalculation();
        let mainCount = 0;
        let adultCount = 0;
        let childCount = 0;
        let singleCount = 0;


        for (let i = 0; i < this.cartItemData.subCategory.length; i++) {

          if (this.cartItemData.subCategory[i].name === "FAMILY MEMBERSHIP") {
            mainCount = this.cartItemData.subCategory[i].totalcount;
          } else if (this.cartItemData.subCategory[i].name === "SINGLE MEMBERSHIP") {
            singleCount = singleCount + this.cartItemData.subCategory[i].count;
          } else if (this.cartItemData.subCategory[i].name === "ADDITIONAL ADULT MEMBERSHIP") {
            adultCount = adultCount + this.cartItemData.subCategory[i].count;
          }
          else if (this.cartItemData.subCategory[i].name === "ADDITIONAL CHILD MEMBERSHIP") {
            childCount = childCount + this.cartItemData.subCategory[i].count;
          }
        }
        for (let i = 0; i < mainCount; i++) {
          if (i <= 3) {
            this.itemControls.push(this.createItemFormGroup1("FAMILY", 'Child'));
          } else {
            this.itemControls.push(this.createItemFormGroup1("FAMILY", 'Adult'));
          }

        }
        for (let i = 0; i < singleCount; i++) {
          this.itemControls.push(this.createItemFormGroup1("SINGLE", 'Adult'));
        }
        for (let i = 0; i < adultCount; i++) {
          this.itemControls.push(this.createItemFormGroup1("ADDITIONAL ADULT", 'Adult'));
        }
        for (let i = 0; i < childCount; i++) {
          this.itemControls.push(this.createItemFormGroup1("ADDITIONAL CHILD", 'Child'));
        }
        let famArray = this.cartItemData.subCategory.find(item => item.name === "FAMILY MEMBERSHIP");
        let singleArray = this.cartItemData.subCategory.find(item => item.name === "SINGLE MEMBERSHIP");
        if (famArray === undefined || singleArray === undefined) {
          if (this.cartItemData.subCategory[0].sub_type === "ADDITIONAL CHILD") {
            this.isChildOnly = true;
          }
          this.myForm.get('items.0').setValue({
            firstname: "",
            lastname: "",
            email: "",
            dob: "",
            relation: '',
            gender: '',
            phoneNumber: '',
            sub_type: this.cartItemData.subCategory[0].sub_type
          });

        }


        // for (let i = 1; i < totalCount; i++) {
        //   this.addItem();
        // }
        for (let i = 0; i < this.cartItemData.subCategory.length; i++) {
          if (i != 0)
            this.subcategoryIds = this.subcategoryIds + "," + this.cartItemData.subCategory[i].id.toString()
          else
            this.subcategoryIds = this.cartItemData.subCategory[i].id.toString()
        }
      } if (this.cartType === "v2-cart") {
        this._mazayaPlusService.getUserInfo().subscribe((res) => {
          this.userInfo = res.data
          this.createFormV2()
        })

      }

      const powerAndExplore = localStorage.getItem('cartPower');
      if (powerAndExplore && powerAndExplore !== "undefined") {
        this.cartType = "power-cart"
        this.isChildOnly = false;
        this.loadCart()

        const price = this.cartPower.grandTotal;
        this.tabbyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://checkout.tabby.ai/promos/product-page/installments/en/?price=${price}&currency=AED`
        );
      }

      const currentUrl = window.location.pathname;

      if (currentUrl == "/mazaya-plus/upgade-check-out/0" || currentUrl == "/mazaya-plus/upgade-check-out/1") {

        this.upgradeMembership()
      }
      if (this.myForm.value.items.length) {

      }
      this.getUserProfile();
      this.initRelationship()
    })
  }
  deleteCart() {
    localStorage.removeItem('cart');
    this._router.navigate(["/mazaya-plus"]);
  }
  deleteSubCategory(i: number) {
    this.cartItemData.subCategory.splice(i, 1);
    if (this.cartItemData?.subCategory[0]?.sub_type === "ADDITIONAL CHILD") {
      this.isChildOnly = true;
      this._notification.clearTabbyErrorMessage();
    }

    if (this.cartItemData.subCategory.length == 0) {

      localStorage.setItem('cart', JSON.stringify([]));
      localStorage.removeItem('cart');
      this._notification.clearTabbyErrorMessage();
      this._router.navigate(["/mazaya-plus"]);

    } else {
      localStorage.setItem('cart', JSON.stringify(this.cartItemData));
      for (let i = 0; i < this.cartItemData.subCategory.length; i++) {
        if (i != 0)

          this.subcategoryIds = this.subcategoryIds + "," + this.cartItemData.subCategory[i].id.toString()

        else
          this._notification.clearTabbyErrorMessage();
        this.subcategoryIds = this.cartItemData.subCategory[i].id.toString()
      }
      this.amountCalculation();
      this._notification.clearTabbyErrorMessage();
    }

  }
  initRelationship() {
    // if (this.userInfo?.mazayaCardCount === 0) {
    //   this.relations = [
    //     { value: 'Myself', viewValue: 'Myself' },
    //     { value: 'Father', viewValue: 'Father' },
    //     { value: 'Mother', viewValue: 'Mother' },
    //     { value: 'Son', viewValue: 'Son' },
    //     { value: 'Daughter', viewValue: 'Daughter' },
    //     { value: 'Spouse', viewValue: 'Spouse' },
    //     { value: 'Other', viewValue: 'Other' },
    //   ]
    // } else {
    //   this.relations = [
    //     { value: 'Father', viewValue: 'Father' },
    //     { value: 'Mother', viewValue: 'Mother' },
    //     { value: 'Son', viewValue: 'Son' },
    //     { value: 'Daughter', viewValue: 'Daughter' },
    //     { value: 'Spouse', viewValue: 'Spouse' },
    //     { value: 'Other', viewValue: 'Other' },
    //   ]
    // }
  }
  onInputTrim(fieldName: string) {
    const control = this.myForm.get(`items.0.${fieldName}`);
    if (!control) return;

    const value = control.value;
    const trimmedValue = value.trimStart();
    if (value !== trimmedValue) {
      control.setValue(trimmedValue);
    }
  }
  roundAmount(amount: number): number {
    return parseFloat(amount.toFixed(2))
  }
  onGenderChange(event: MatRadioChange) {
    this.userGender = event.value;
  }

  amountCalculationPowerCart() {
    this.totalAmount = this.cartPower.totalAmount;
    this.totalVat = this.cartPower.totalVat;
    this.subtotalAmount = this.cartPower.totalAmount + this.discountAmount
    this.grandTotalAmount = this.subtotalAmount + this.totalVat

    this.subtotalAmount = (this.totalAmount - this.discountAmount) >= 0 ? this.totalAmount - this.discountAmount : 0.00
    this.totalVat = this.roundAmount((this.subtotalAmount * 0.05) >= 0 ? this.subtotalAmount * 0.05 : 0.00)
    this.grandTotalAmount = this.subtotalAmount + this.totalVat
  }

  amountCalculationV2() {
    this.totalVat = 0;
    this.totalAmount = 0;

    if (!this.appliedCouponCode) {

      for (let i = 0; i < this.cartItemV2Data[0].membershipTypes.length; i++) {
        this.totalVat = this.totalVat + (this.cartItemV2Data[0].membershipTypes[i].vat) * this.cartItemV2Data[0].membershipTypes[i].selectedCount
        this.totalAmount = this.totalAmount + (this.cartItemV2Data[0].membershipTypes[i].amount) * this.cartItemV2Data[0].membershipTypes[i].selectedCount
        this.subtotalAmount = this.totalAmount;
      }


    } else {
      for (let i = 0; i < this.cartItemV2Data[0].membershipTypes.length; i++) {
        this.totalAmount = this.totalAmount + (this.cartItemV2Data[0].membershipTypes[i].amount) * this.cartItemV2Data[0].membershipTypes[i].selectedCount
        this.subtotalAmount = this.roundAmount((this.totalAmount - this.discountAmount) >= 0 ? this.totalAmount - this.discountAmount : 0.00)
        this.totalVat = this.roundAmount((this.subtotalAmount * 0.05) >= 0 ? this.subtotalAmount * 0.05 : 0.00)
      }
    }
    this.grandTotalAmount = this.subtotalAmount + this.totalVat


  }
  onIncrementV2(i: number) {
    if (this.cartItemV2Data[0].membershipTypes[i].selectedCount != this.cartItemV2Data[0].membershipTypes[i].totalCount) {
      this.cartItemV2Data[0].membershipTypes[i].selectedCount++
      this._storageService.setMazayaMembershipV2(this.cartItemV2Data)
      this._notification.clearTabbyErrorMessage();
      this.amountCalculationV2()
      if (this.cartItemV2Data[0].membershipTypes[i].cardName === "ADDITIONAL ADULT MEMBERSHIP") {
        this._notification.clearTabbyErrorMessage();
        this.itemControls.push(this.createItemFormGroup1("ADDITIONAL ADULT", 'Adult'));
      } else if (this.cartItemV2Data[0].membershipTypes[i].cardName === "ADDITIONAL CHILD MEMBERSHIP") {
        this._notification.clearTabbyErrorMessage();
        this.itemControls.push(this.createItemFormGroup1("ADDITIONAL CHILD", 'Child'));
      }
    } else {
      this._notification.error(
        "",
        "Maximum count reached"
      );
    }

  }

  onDecrementV2(i: number) {
    if (this.cartItemV2Data[0].membershipTypes[i].selectedCount !== 0) {
      this.cartItemV2Data[0].membershipTypes[i].selectedCount--
      this._storageService.setMazayaMembershipV2(this.cartItemV2Data)
      this._notification.clearTabbyErrorMessage();
      if (this.cartItemV2Data[0].membershipTypes.length > 1 && this.userInfo?.mazayaCardCount != 0) {
        this.removeItem(0)

      } else {
        this.removeItem(this.itemControls.controls.length - 1)

      }

      if (this.cartItemV2Data[0].membershipTypes[i].selectedCount == 0)

        this.deleteSubCategoryV2(i);
      this.amountCalculationV2();
    }
  }
  deleteSubCategoryV2(i: number) {

    this.cartItemV2Data[0].membershipTypes.splice(i, 1);
    if (this.cartItemV2Data[0]?.membershipTypes[0]?.cardName === "ADDITIONAL CHILD MEMBERSHIP") {
      this.isChildOnly = true;
      this._notification.clearTabbyErrorMessage();
    }

    if (this.cartItemV2Data[0].membershipTypes.length == 0) {

      localStorage.setItem('v2-cart', JSON.stringify([]));
      localStorage.removeItem('v2-cart');
      this._notification.clearTabbyErrorMessage();
      this._router.navigate(["/mazaya-plus"]);

    } else {

      localStorage.setItem('v2-cart', JSON.stringify(this.cartItemV2Data));
      // this.amountCalculationV2();
      this.itemControls.clear()
      this._notification.clearTabbyErrorMessage();
      this.createFormV2()
    }

  }
  mobileValidator(mobileNumber: string) {

    if (mobileNumber.length === 9 || mobileNumber.length === 10) {
      this.mobileNumberError = false;
      return true;
    } else {
      this.mobileNumberError = true;
      return false;
    }

  }
  mobileNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value || '';
    if (value.length === 9 || value.length === 10) {
      //console.log("dfdf")
      return null; // Valid
    }
    return { invalidMobileNumber: true }; // Invalid
  }
  deleteCartV2() {
    localStorage.removeItem('v2-cart');
    this._notification.clearTabbyErrorMessage();
    this._router.navigate(["/mazaya-plus"]);
  }

  upgradeMembership() {
    this.isUpgrade = true
    this._mazayaPlusService.getUpgradeMembership(this.userInfo?.isGoldmembership).subscribe((res) => {
      const response = res.data.cards
      const index = parseInt(this._route.snapshot.params.index)
      this.upgradTo = res.data.typeId
      this.cartItemV2Data = res.data.cards
      //console.log("categoryList", this.cartItemV2Data)
      const cards = this.cartItemV2Data?.filter(i => i.count != 0)
      this.upgradSubIds = cards.map(card => card.cardId).join(',');

      this.cartItemV2Data?.forEach((item, i) => {


        if (i == 0) {
          this.upgradeAmountTotal = this.upgradeAmountTotal + item.amount
          this.totalAmount = this.upgradeAmountTotal + item.amount
          this.upgradeVatTotal = this.upgradeVatTotal + item.vat
        } else {
          this.upgradeAmountTotal = this.upgradeAmountTotal + item.amount * item.count
          this.upgradeVatTotal = this.upgradeVatTotal + item.vat * item.count
        }

      })

      this.calculateUpgradeAmount()


    })
  }
  // this._mazayaPlusService.getUserProfile().subscribe(res => {
  //   this.userFirstName = res.firstname;
  //   this.userLastName = res.lastname;
  //   this.userEmail = res.email;
  //   this.phoneNumber = res.phoneNumber.substring(3);
  //   this.gender = res.gender;
  //   if (this.userInfo?.mazayaCardCount === 0) {

  //     this.isCreatedCard = false

  //     this.myForm.get('items.0').setValue({
  //       firstname: res.firstname,
  //       lastname: res.lastname,
  //       email: res.email,
  //       dob: '',
  //       relation: 'Myself',
  //       sub_type: this.myForm.get('items.0.sub_type').value,
  //       phoneNumber: this.phoneNumber,
  //       gender: this.gender
  //     });
  //   } else {
  //     this.isCreatedCard = true;
  //   }
  // })
  upgradeConfirm() {
    if (!this.selectedPaymentMethod) {
      this.showError = true;
      this._notification.error("", "Please select a payment method before proceeding.");
      return;
    } else {
      this.showError = false;
    }
    const rqBody = {
      "amount": this.upgradeAmountTotal,
      "vat": this.upgradeVatTotal,
      "category_id": this.upgradTo,
      "subcategoryIds": this.upgradSubIds
    }

    this._mazayaPlusService.upgradeMembership(rqBody).subscribe((res) => {
      const lastTransaction: { type: string, transactionId: string } = {
        type: "v2-cart",
        transactionId: res.data
      }
      const email = JSON.parse(localStorage.getItem('auth.email'));

      // localStorage.setItem('lastTransaction', JSON.stringify(lastTransaction))
      // this.handlePayment(res.data, email)
      localStorage.setItem('lastTransaction', JSON.stringify(lastTransaction))
      if (this.selectedPaymentMethod === 'Credit/Debit Card') {

        this.handlePayment(res.data, this.userEmail);
      } else if (this.selectedPaymentMethod === 'Tabby') {

        this.createUpgradeWithTabby(res.data);
      }

    })
  }
  upgradeGoldAddOnConfirm() {
    if (!this.selectedPaymentMethod) {
      this.showError = true;
      this._notification.error("", "Please select a payment method before proceeding.");
      return;
    } else {
      this.showError = false;
    }
    const rqBody = {
      "amount": this.subtotalAmount,
      "vat": this.totalVat,
      "category_id": this.upgradTo,
      "subcategoryIds": this.upgradSubIds,
      "isgoldaddon": "true",
      "couponId": this.CouponCodeId == 0 ? null : this.CouponCodeId
    }

    this._mazayaPlusService.upgradeToGoldAddOn(rqBody).subscribe((res) => {
      const lastTransaction: { type: string, transactionId: string } = {
        type: "v2-cart",
        transactionId: res.data
      }
      const email = JSON.parse(localStorage.getItem('auth.email'));

      localStorage.setItem('lastTransaction', JSON.stringify(lastTransaction))
      if (this.grandTotalAmount != 0) {
        if (this.selectedPaymentMethod === 'Credit/Debit Card') {
          this.handlePayment(res.data, email)
        }
        else if (this.selectedPaymentMethod === 'Tabby') {

          this.createUpgradeWithTabby(res.data);
        }
      } else {
        this.updateECardStatusWithoutPayment(res.data)
      }

    })

  }
  createUpgradeWithTabby(transaction_id: number) {
    //console.log("createPaymentWithTabby called with transaction_id:", transaction_id);

    this._mazayaPlusService.getUserProfile().subscribe((res: any) => {
      // Extract user details from the response
      const userFirstName = res.data.firstName;
      const userLastName = res.data.lastName;
      const userEmail = res.data.email;
      const phoneNumber = res.data.phoneNumber.substring(3);
      const gender = res.data.gender;

      //console.log("aaaaaaaaaaaa", this.cartItemV2Data)
      const mazayaecarddetails: MazayaEcardDetail[] = [
        {
          email: userEmail,
          dob: '',
          relation: 'myself',
          lastname: userLastName,
          firstname: userFirstName,
          sub_type: '',
          mazayaEcardmainId: 0,
          gender: gender,
          phone: phoneNumber
        }
      ];

      const mazayaecardmain: MazayaeEcardMain = {
        category_id: this.upgradTo,
        vat: this.totalVat,
        amount: this.totalAmount,
        currency: this.cartItemV2Data[0]?.cards[0].currency,
        id: this.upgradTo,
        subcategoryIds: this.upgradSubIds,
      };
      const buyerHistory: BuyerHistory = {
        registered_since: '',
        loyalty_level: 0
      }
      const tabbyItem: TabbyItem[] = this.cartItemV2Data[0].membershipTypes.map((item: any) => ({
        title: item.cardName,
        quantity: item.count,
        unit_price: item.amount,
        category: this.cartItemV2Data[0].type
      }))

      const orderHistory: Order[] = [{
        purchased_at: new Date().toISOString(),
        amount: this.totalAmount,
        status: "new",
        buyer: {
          phone: phoneNumber,
          email: userEmail,
          name: userFirstName + " " + userLastName
        },
        shipping_address: {
          city: "Abu Dhabi Auh",
          address: "Auh",
          zip: "000000"
        }
      }]

      const tabbyPaymentData: TabbyPaymentRequest = {
        additional_count: 0,
        mazayaecarddetails: mazayaecarddetails,
        mazayaecardmain: mazayaecardmain,
        buyerHistory: buyerHistory,
        orderHistory: orderHistory,
        items: tabbyItem,
        device_type: 'web',
        name: "Family",
        booking_id: transaction_id,
        description: "Mazaya Ecard Payment",

      };

      //console.log("TabbyPaymentData:", tabbyPaymentData);


      this._mazayaPlusService.createPayment(tabbyPaymentData).subscribe(
        (response) => {
          //console.log("Tabby payment response:", response);
          const paymentUrl = response.data;
          window.location.href = paymentUrl;
        },
        (error) => {
          console.error("Tabby payment request failed:", error);
        }
      );
    });
  }

  checkStartsWith971(input: string): boolean {
    return input.startsWith("971");
  };
  handleRightArrow() {
    //console.log("itemControls.controls", this.itemControls.controls)
    if (this.currentMember !== this.itemControls.controls.length) {
      this.currentMember++;
      if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'FAMILY') {

        this.isChildOnly = this.currentMember > 2 ? true : false
        this.isNannyOnly = false
        this.filterMemberList(this.isChildOnly)
      }
      if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'ADDITIONAL ADULT') {
        this.isChildOnly = false
        this.isNannyOnly = false
        this.filterMemberList(this.isChildOnly)
      }
      if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'ADDITIONAL CHILD') {
        this.isChildOnly = true
        this.isNannyOnly = false
        this.filterMemberList(this.isChildOnly)
      }
      if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'NANNY SERVICE') {
        this.isChildOnly = false
        this.isNannyOnly = true
        const nannyData = this.membershipDetails.find(item => item.type === 'N' && item.firstname != '')
        if (nannyData != undefined){
                    this.filteredMembers = []
          this.filteredMembers.push(nannyData)
        }
        else
          this.filteredMembers = []
      }

    }

  }
  handleLeftArrow() {
    if(this.currentMember==1)
      return
    this.currentMember--;
    if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'FAMILY') {
      this.isChildOnly = this.currentMember > 2 ? true : false
      this.isNannyOnly = false
      this.filterMemberList(this.isChildOnly)
    }
    if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'ADDITIONAL ADULT') {
      this.isChildOnly = false
      this.isNannyOnly = false
      this.filterMemberList(this.isChildOnly)
    }
    if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'ADDITIONAL CHILD') {
      this.isChildOnly = true
      this.isNannyOnly = false
      this.filterMemberList(this.isChildOnly)
    }
    if (this.myForm.get(`items.${this.currentMember - 1}.sub_type`).value == 'NANNY SERVICE') {
      this.isChildOnly = false
      this.isNannyOnly = true
      const nannyData = this.membershipDetails.find(item => item.type === 'N' && item.firstname != '')
      if (nannyData != undefined)
        this.filteredMembers.push(nannyData)
      else
        this.filteredMembers = []
    }

  }
  onMemberTypeChange(event: MatRadioChange, i: number) {
    const selectedValue = event.value;


    const itemForm = this.myForm.get(`items.${i}`) as FormGroup;



    itemForm.get('firstname')?.enable();
    itemForm.get('lastname')?.enable();


  }
  filterMemberList(isChild: boolean) {
    const temp: any = this.membershipDetails
    this.filteredMembers = []
    temp?.forEach((element, i) => {

      const adult = this.checkAdult(element.dob)

      if (adult && !isChild && element.firstname != '' &&  element.relation!='Myself' && element.type != 'N') {
        //console.log("ddddddd", adult, element.dob)
        this.filteredMembers.push(element)
      }
      if (!adult && isChild && element.firstname != '') {
        this.filteredMembers.push(element)
      }

    });

  }
  getFilteredMembers(index: number) {
    return this.filteredMembers.filter(member =>
      !this.selectedMemberIds.includes(member.id) ||
      this.selectedMemberIds[index] === member.id
    );
  }

  onChoosenMember(event: MatSelectChange) {
    const selectedId = event.value;
    const formIndex = this.currentMember - 1;

    // Remove previous selection for this index
    this.selectedMemberIds[formIndex] = null;
    this.selectedMemberIds[formIndex] = selectedId;

    const member = this.membershipDetails.find(m => m.id === selectedId);
    if (!member) return;

    const itemForm = this.myForm.get(`items.${formIndex}`) as FormGroup;

    itemForm.patchValue({
      firstname: member.firstname,
      lastname: member.lastname,
      email: member.email,
      dob: member.dob,
      relation: member.relation,
      gender: member.gender,
      phoneNumber: member.PhoneNumber.substring(3),
      profile_image: member.profile_img,
      selection: 'existing',
      memberType: this.checkAdult(member.dob) ? 'Adult' : 'Child'
    });

    itemForm.get('firstname')?.disable();
    itemForm.get('lastname')?.disable();
  }
  checkAdult(dob: string): boolean {
    if (!dob) {
      return false;
    }
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    const value = age >= 18;
    return value
  }
  onCancel() {
    this.isOpen = false;
  }
  toggleTabbyPromo() {
    this.showTabbyPromo = !this.showTabbyPromo;

    if (this.showTabbyPromo) {

      this.initializeTabbyPromo();

    }
  }

  clearErrorMessage(): void {
    this._notification.clearTabbyErrorMessage();
  }
  openTabbyModal(event: Event) {

    //console.log("tabby", this.isTabbyModalOpen)
    event.preventDefault();
    //console.log("Tabby Modal Clicked");
    this.selectedTabbyUrl = this.tabbyUrl;
    //console.log("Selected Tabby URL:", this.selectedTabbyUrl);
    this.isTabbyModalOpen = true;
    //console.log("tabby2", this.isTabbyModalOpen)
  }

  closeTabbyModal(): void {
    this.isTabbyModalOpen = false;
    this.selectedTabbyUrl = null;
  }

  buyerTerms() {
    this.loginService.getBuyerTermsAndCondition().subscribe((res: any) => {
      this.buyerTermsContent = res.data[0].content;
    });
  }
  openCloseTermsCondition(value: boolean) {
    this.visibleTermsConditions = value
  }
  applyCouponCode() {
    this._mazayaPlusService.validateCoupon({ CouponCode: this.couponCode })
      .subscribe((res) => {
        //console.log("CouponCode", res)
        if (res.data.statusCode == 200) {
          if (res.data.CouponCodeValue >= this.totalAmount) {
            this.CouponCodeId = res.data.CouponCodeId;
            this.discountAmount = res.data.CouponCodeValue;
            this.discountModal = true;
          } else {
            this.CouponCodeId = res.data.CouponCodeId
            this.discountAmount = res.data.CouponCodeValue;
            this.appliedCouponCode = true;
            if (this.cartType == 'v2-cart')
              this.amountCalculationV2();
            if (this.cartType == 'power-cart')
              this.amountCalculationPowerCart();
            if (this.isUpgrade)
              this.calculateUpgradeAmount()
          }

        }

      })

  }
  removeCouponCode() {
    this.appliedCouponCode = false;
    this.couponCode = '';
    this.haveCouponCode = false;
    this.CouponCodeId = 0
    this.discountAmount = 0
    if (this.cartType == 'v2-cart')
      this.amountCalculationV2();
    if (this.cartType == 'power-cart')
      this.amountCalculationPowerCart();
    if (this.isUpgrade)
      this.calculateUpgradeAmount()

  }
  closeDiscountModal() {
    this.discountModal = false
    this.removeCouponCode()
  }
  proceedWithDisc() {
    this.discountModal = false
    this.appliedCouponCode = true;
    if (this.cartType == 'v2-cart')
      this.amountCalculationV2();
    if (this.cartType == 'power-cart')
      this.amountCalculationPowerCart();
    if (this.isUpgrade)
      this.calculateUpgradeAmount()
  }

  updateECardStatusWithoutPayment(id: number) {
    const paymentData = {
      Amount: 0.0,
      Device: "web",
      Deviceid: "",
      Paystatus: "true",
      authorization_code: "",
      card_holder_name: "",
      card_number: "",
      currency: "AED",
      cust_email: this.loginEmail,
      customer_ip: "",
      eci: "",
      expiry_date: "",
      fort_id: "",
      merchant_reference: "",
      payment_option: "",
      response_code: "14000",
      response_msg: "Success",
      signature: ""
    };
    this._mazayaPlusService.updateEcardPaymentStatus(paymentData, id)
      .subscribe((res) => {
        if (res.statusCode === 200) {
          this._router.navigate(['/home/payment-success']);
        }
      })
  }
  updatePowerExploreStatusWithoutPayment(id: number) {
    const paymentData = {
      Amount: 0.0,
      Device: "web",
      Deviceid: "",
      Paystatus: "true",
      authorization_code: "",
      card_holder_name: "",
      card_number: "",
      currency: "AED",
      cust_email: this.loginEmail,
      customer_ip: "",
      eci: "",
      expiry_date: "",
      fort_id: "",
      merchant_reference: "",
      payment_option: "",
      response_code: "14000",
      response_msg: "Success",
      signature: ""
    };
    this._mazayaPlusService.updatePowerExplorePaymentStatus(paymentData, id)
      .subscribe((res) => {

        this._router.navigate(['/home/payment-success']);

      })
  }

  calculateUpgradeAmount() {
    this.totalAmount = this.upgradeAmountTotal

    this.subtotalAmount = (this.totalAmount - this.discountAmount) >= 0 ? this.totalAmount - this.discountAmount : 0.00
    this.totalVat = this.roundAmount((this.subtotalAmount * 0.05) >= 0 ? this.subtotalAmount * 0.05 : 0.00)

    this.grandTotalAmount = this.subtotalAmount + this.totalVat
  }

  shouldShowMemberSelection(i: number): boolean {
    const itemForm = this.myForm.get(`items.${i}`) as FormGroup;
    const relation = itemForm.get('relation')?.value;

    if (relation === 'Myself') {
      return false;
    }

    if (!this.isRenew && this.filteredMembers?.length==0) {
      return false;
    }

    if(this.userInfo.isAbletoRenew && !this.haveMainCard){
        return false;
    }
    if (!this.filteredMembers?.length) {
      return false;
    }

    if (!this.getFilteredMembers(i)?.length) {
      return false;
    }

    return true;
  }
}
